export default __webpack_public_path__ + "static/media/738.ca1f18a3.gif";